"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _deleteButton = _interopRequireDefault(require("../../../../core/delete-button"));
var _addRaceEligibility = _interopRequireDefault(require("./add-race-eligibility"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("th", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("th", null, "Ranked Class");
var _ref3 = /*#__PURE__*/_react.default.createElement("th", null, "Ranked Division");
var _ref4 = /*#__PURE__*/_react.default.createElement("th", null, "Can Enter As");
class Eligibilities extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      errorMessage: null
    });
    _defineProperty(this, "_onDeleteEligibility", id => {
      this.props.onDelete(id);
    });
    _defineProperty(this, "_onSetError", errorMessage => {
      this.setState({
        errorMessage
      });
    });
    _defineProperty(this, "_onErrorDismissed", () => {
      this.setState({
        errorMessage: null
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !this.state.errorMessage ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onErrorDismissed
      }, "OK"),
      onClose: this._onErrorDismissed
    }, this.state.errorMessage), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, !this.props.userCanModifyCompetitionStructure ? null : _ref, _ref2, _ref3, _ref4)), /*#__PURE__*/_react.default.createElement("tbody", null, this.props.eligibilities.map(eligibility => /*#__PURE__*/_react.default.createElement("tr", {
      key: eligibility.id
    }, !this.props.userCanModifyCompetitionStructure ? null : /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      size: "sm",
      onClick: this._onDeleteEligibility.bind(this, eligibility.id)
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, eligibility.classDivision.classDescription), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, eligibility.classDivision.rankingDivisionDescription), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, eligibility.entryType.description))), !this.props.userIsSystemAdmin ? null : /*#__PURE__*/_react.default.createElement(_addRaceEligibility.default, {
      raceID: this.props.raceID,
      onSetError: this._onSetError
    }))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(Eligibilities, undefined, (client, props) => ({
  onDelete(id) {
    return client.update('RaceEligibility.delete', {
      id
    });
  }
}));